import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardText,
 } from "reactstrap"
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { toast } from "react-toastify"
import AppoinmentService from "services/Admin/AppoinmentService"


function ModalForm({ modal, toggle, status,item, id, setShouldGetData }) {
    const [formData, setFormData] = useState({
        status: ""
    })
    const appoinmentService = new AppoinmentService()
    const [loading, setLoading] = useState(false)


    useEffect(() => {
        setFormData({ ...formData, status })
    }, [status])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const ChangeStatusHandler = (_, values) => {
        setLoading(true)
        const data={
            status:formData.status
        }
          appoinmentService.toggleStatus(id,data).then(res => {
            if (res && res.status === SuccessOk) {
                setShouldGetData(true)
                toast.success("Status changed successfully")
                toggle()
            }else{
                setLoading(false)
            }
        })
    }
    return (
        <AvForm
            className='form-horizontal'
            onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
            }}>
            <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
                <ModalHeader toggle={toggle}>
                    Change Status
                <br />
                    <span className="font-size-14" style={{ opacity: .5, }}>Change Status of the Appointment</span>
                </ModalHeader>
                <ModalBody>

                    <Row>
                        <Col className="m-0">
                            <CardText tag='h6' className='fw-bold'>
                                Status
                  </CardText>
                            <AvRadioGroup className="mt-2" name="status" value={formData.status} onChange={handleFieldChange} >
                                <AvRadio label="Upcoming" value="Upcoming" />
                                <AvRadio label="Done" value="Done" />
                                <AvRadio label="Canceled" value="Canceled" />
                             </AvRadioGroup>
                        </Col> 
                    </Row>
                </ModalBody>

                <ModalFooter className="p-0 pt-1 m-0 d-flex justify-content-end">
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-secondary'>
                        Cancel
                        </button>
                    <button
                        type='button'
                        onClick={ChangeStatusHandler}
                        disabled={loading ? true:false}
                        className='btn btn-success'>
                        Submit
                        </button>
                </ModalFooter>
            </Modal>
        </AvForm>

    )
}

export default ModalForm
